export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const DEFAULT_STOCK = {
  cashCenterId: "",
  customerId: "",
  description: "",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  topSerialNo: "",
  bottomSerialNo: "",
};

export const CASSETTES_TYPES = [
  {
    value: "Type 1",
    label: "Type 1",
  },
  {
    value: "Type 2",
    label: "Type 2",
  },
  {
    value: "Type 3",
    label: "Type 3",
  },
  {
    value: "Type 4",
    label: "Type 4",
  },
  {
    value: "Type 5",
    label: "Type 5",
  },
  {
    value: "Type 6",
    label: "Type 6",
  },
];
